import { defineNuxtRouteMiddleware } from '#imports'

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.client && window.Didomi) {
    window.didomiOnReady.push(() => {
      window.Didomi?.notice.hide()
    })
  }
})
